// Lib
import * as Immutable from 'immutable';

// Constants
import {
    COMMENTS_ADD,
    COMMENTS_UPDATE,
    COMMENTS_PRE_COMMIT,
    COMMENTS_CLEAR_PRE_COMMIT,
    COMMENTS_STOP_EDITING,
    COMMENTS_START_EDITING,
    COMMENTS_CANCEL_EDITING,
    COMMENTS_DELETE,
} from '../../../../common/comments/commentConstants';
import { USER_NAVIGATE } from '../../../../common/users/userConstants';

const initialState = Immutable.fromJS({
    currentlyEditingId: null,
    map: {},
});

export default (state = initialState, action) => {
    switch (action.type) {
        case COMMENTS_STOP_EDITING:
            return state.set('currentlyEditingId', null).setIn(['map', action._id, 'isEditing'], false);
        case COMMENTS_START_EDITING:
            return state.set('currentlyEditingId', action._id).setIn(['map', action._id, 'isEditing'], true);
        case COMMENTS_PRE_COMMIT:
            return state
                .set('currentlyEditingId', action._id)
                .setIn(['map', action._id, 'text'], Immutable.fromJS(action.text));
        case COMMENTS_CLEAR_PRE_COMMIT:
            return state.setIn(['map', action._id, 'text'], null);
        case COMMENTS_CANCEL_EDITING:
        case COMMENTS_UPDATE:
        case COMMENTS_DELETE:
            return state.deleteIn(['map', action._id]).set('currentlyEditingId', null);
        case COMMENTS_ADD:
            return state.deleteIn(['map', action.threadId]).set('currentlyEditingId', null);
        case USER_NAVIGATE:
            return initialState;
        default:
            return state;
    }
};
